// extracted by mini-css-extract-plugin
module.exports = {"form":"src-pages-HubeiTest-__index__form--3vP1z"};